import { pdpSharedNotificationMultiplePdpVisitsModalConfig as pdpSharedMultiplePdpVisitsModalConfig } from './PdpSharedNotificationMultiplePdpVisitsModal/pdpSharedNotificationMultiplePdpVisitsModalConfig';

export const pdpSharedNotifications = [pdpSharedMultiplePdpVisitsModalConfig];
